import { StickyActionElement } from "@omni/types/components/general/enums/stickyActionElement.enum";
import { Breakpoint } from "@omni/types/enums/breakPoint.enum";
import { cn } from "@omni/utils/styles";
import { ReactNode, useEffect } from "react";

import { Portal } from "@/components/General/Portal/portal";
import { getStickyActionsRoot } from "@/components/StickyAction/helpers";
import { useThunkDispatch } from "@/redux/dispatcher";
import * as StickyActionsModule from "@/redux/modules/value/stickyActions/stickyActions.module";
import {
    useIsBreakpoint,
    withBreakpoints
} from "@/utils/breakpoints/breakpoints.provider";

type Props = {
    stickyActionElement: StickyActionElement;
    hiddenBreakpoint?: Breakpoint;
    children: ReactNode;
};

const _StickyAction = ({
    stickyActionElement,
    hiddenBreakpoint,
    children
}: Props) => {
    const dispatch = useThunkDispatch();

    const { matches, ready } = useIsBreakpoint(hiddenBreakpoint);

    useEffect(() => {
        if (!ready || matches) return;

        dispatch(StickyActionsModule.addReference());

        return () => {
            dispatch(StickyActionsModule.removeReference());
        };
    }, [matches, ready, dispatch]);

    if (!ready || matches) return null;

    const stickyActionsRoot = getStickyActionsRoot();

    return (
        <Portal target={stickyActionsRoot}>
            <div
                className={cn(
                    {
                        "tw:w-full":
                            stickyActionElement ===
                                StickyActionElement.AddToCartButton ||
                            stickyActionElement ===
                                StickyActionElement.CheckoutButton,
                        "tw:w-full tw:md:w-auto tw:md:ml-auto":
                            stickyActionElement ===
                            StickyActionElement.ComparisonButton
                    },
                    {
                        "tw:order-1":
                            stickyActionElement ===
                            StickyActionElement.FeatureSwitchButton,
                        "tw:order-2":
                            stickyActionElement ===
                            StickyActionElement.AddToCartButton,
                        "tw:order-3":
                            stickyActionElement ===
                            StickyActionElement.CheckoutButton,
                        "tw:order-4":
                            stickyActionElement ===
                            StickyActionElement.ComparisonButton
                    }
                )}
            >
                {children}
            </div>
        </Portal>
    );
};

export const StickyAction = withBreakpoints(_StickyAction);
